import React, {MouseEventHandler} from "react"
import {useRouteMatch} from "react-router"
import {Link} from "react-router-dom"
import styles from "./navigation-link.module.scss"
import {MaterialIcon} from "../../../components-shared/material-icon/material-icon-view"

export interface NavigationLinkProps {
  to: string
  onlyActiveWhenExactMatch?: boolean
  materialIconName: string
  onLinkClick: MouseEventHandler
}

export const NavigationLink: React.FC<NavigationLinkProps> = ({to, onlyActiveWhenExactMatch = false, materialIconName, onLinkClick, children}) => {
  const active = useRouteMatch({
    path: to,
    exact: onlyActiveWhenExactMatch
  }) !== null
  const className = `${active ? styles.Active : styles.Inactive}`

  return (
    <Link to={to}
          className={className}
          onClick={onLinkClick}>
      <div className={styles.Icon}>
        <MaterialIcon name={materialIconName} size="large"/>
      </div>
      {children}
    </Link>
  )
}

